import React from "react";
import Disease from "./Disease";

// Page displayed in url: https://varsome.com/disease/30010000007433
const DiseasePage = () => {
  return (
    <section className="no-vert-padding no-stretching">
      <Disease />
    </section>
  );
};

export default DiseasePage;
